import React from 'react';
import { Link } from '@reach/router';
import moment from 'moment';

import styles from './ClassProjects.module.scss'
import { BOOK_STATUS, CHAPTER_STATUS } from '@squirrellearningltd/go-shared-utils';
import { ProgressBar } from '@squirrellearningltd/go-pupil-components';

import noCover from '../../../../images/no-cover.png';
import taskCover from '../../../../images/task.png';

const isPublished = (book) => book.status >= BOOK_STATUS.completed;
const isDisabled = (book) =>
    (book.isSingleChapter && book.chapters[0].status < CHAPTER_STATUS.writing) ||
    (!book.isSingleChapter && book.currentChapter === 0) ||
    (!book.isSingleChapter && book.currentChapter === 1 && book.chapters[1].status < CHAPTER_STATUS.writing);

const getEligibleBooks = (books = []) =>
    books.filter(book => !isPublished(book) && !isDisabled(book));

const ClassProjects = ({ books, showFirstX }) => {
    const eligibleBooks = getEligibleBooks(books);

    if (eligibleBooks.length === 0) {
        return <p>Nothing to do at the moment!</p>
    }
    const booksToShow = showFirstX ? eligibleBooks.slice(0, showFirstX) : eligibleBooks;

    return booksToShow.map(book => <ClassProject key={book.id} book={book} />);
}

const ClassProject = ({ book }) => {
    const getSubtitle = () => {
        if (book.classPack?.isWritingActivity && book.status >= BOOK_STATUS.completed) {
            return moment(book.completedAt).format('MMMM YYYY');
        } else {
            if (book.status >= BOOK_STATUS.completed) {
                return 'Published!'
            }
            if (book.chapters[book.currentChapter]?.status === CHAPTER_STATUS.writing) {
                return 'Write Now!';
            }
            if (book.chapters[book.currentChapter]?.status === CHAPTER_STATUS.writing_closed || book.chapters[book.currentChapter]?.status === CHAPTER_STATUS.voting_ready) {
                return 'Writing has ended!';
            }
            if (book.chapters[book.currentChapter]?.status === CHAPTER_STATUS.voting) {
                return 'Vote Now!'
            }
            if (book.chapters[book.currentChapter]?.status === CHAPTER_STATUS.voting_closed) {
                return 'Voting has ended!';
            }
            return null;
        }

    }
    return (
        <Link key={`book-${book.id}`} to={`book/${book.id}`} className={styles.dashboardBookCard}>
            <img
                width={80}
                height={100}
                src={book.bookTemplate?.coverUrl || (book.classPack?.isWritingActivity ? taskCover : noCover)}
                alt={book.title || book.bookTemplate?.name}
            />
            <div className={styles.dashboardBookCardContent}>
                <span className={styles.dashboardBookCardSubTitle}>{getSubtitle()}</span>
                <h2 className={styles.dashboardBookCardTitle}>{book.title || book.bookTemplate?.name}</h2>


                Chapter { book.currentChapter } / { book.chapters.length }
                <ProgressBar progress={(book.currentChapter / book.chapters.length) * 100} backgroundColor='#628D10' />
            </div>

        </Link>
    );
}

export default ClassProjects;